import { Button, Flex, Icon, InputItem, List, NavBar } from "antd-mobile";
import { useEffect, useState } from "react";
import instance from "../../../../util/axios";
import { formatNumber } from "../util";
import { TrainingProduct } from "./TrainingStepTwo";

export interface TrainingBudget {
  uuid: string;
  name: string;
  amount: string;
}

export interface TrainingBudgetWrapper {
  descriptions: TrainingBudget[];
  total: string;
  disabledForm: any;
}

interface TrainingStepThreeProps {
  onCancel?: () => void;
  onOk?: (data: TrainingBudgetWrapper) => void;
  productData: TrainingProduct;
}

const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let moneyKeyboardWrapProps: object | undefined;
if (isIPhone) {
  moneyKeyboardWrapProps = {
    onTouchStart: (e: { preventDefault: () => any }) => e.preventDefault(),
  };
}

const TrainingStepThree = ({
  onCancel,
  onOk,
  productData,
}: TrainingStepThreeProps) => {
  // const [data, setData] = useState<TrainingBudget>({});
  const [descriptions, setDescriptions] = useState<any[]>([]);
  const [selectedDescriptionsIds, setSelectedDescriptionsIds] = useState<any[]>(
    []
  );
  const [total, setTotal] = useState("");
  const [disabledForm, setDisableForm] = useState<any>({
    预计毛利: "",
    预计毛利率: "",
    收入额: "",
    业绩系数: "",
    销售业绩额: "",
    应付小计: "",
    应收小计: "",
  });

  useEffect(() => {
    instance
      .post(`/wf/form/vsheet/rpc`, {
        method: "getBudget",
        workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
        paramsJson: JSON.stringify({}),
      })
      .then((resp) => {
        if (resp.data.Status === "1") {
          setDescriptions(resp.data.Data);
          instance
            .post(`/wf/form/vsheet/rpc`, {
              method: "getCostCategory",
              workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
              paramsJson: JSON.stringify({}),
            })
            .then((res) => {
              if (res.data.Status === "1" && res.data.Data) {
                const data = resp.data.Data.filter((item: { uuid: string }) =>
                  res.data.Data.some(
                    (el: { uuid: string }) => el.uuid === item.uuid
                  )
                );
                setSelectedDescriptionsIds(
                  data.map((item: { uuid: string }) => item.uuid)
                );
              }
            });
        }
      });
  }, []);

  useEffect(() => {
    if (productData) {
      const amount = parseFloat(productData.amount || "0");
      setDisableForm((prevState: any) => ({
        ...prevState,
        应付小计: productData.amount,
        应收小计: productData.amount,
        预计毛利: productData.amount,
        预计毛利率: "100",
        收入额: productData.amount,
        销售业绩额: productData.amount,
        业绩系数:
          amount > 33000
            ? "1.7"
            : amount > 22000
            ? "1.6"
            : amount > 11000
            ? "1.5"
            : "1",
      }));
    }
  }, [productData]);

  return (
    <>
      <NavBar
        className="orderNavBar"
        icon={<Icon type="left" onClick={onCancel} />}>
        销售及内训订单
      </NavBar>
      <List className="mt45">
        <div className="titleDiv">产品1</div>
        {descriptions.length > 0 &&
          descriptions.map((description) => (
            <InputItem
              placeholder={
                description.uuid === "01237019848f11e7832f006617543a41"
                  ? ""
                  : "请输入"
              }
              extra="元"
              disabled={
                description.uuid === "01237019848f11e7832f006617543a41"
                  ? true
                  : false
              }
              key={description.uuid}
              value={description.amount}
              type="money"
              moneyKeyboardWrapProps={moneyKeyboardWrapProps}
              onChange={(value) => {
                const newData = JSON.parse(JSON.stringify(descriptions));
                const index = newData.findIndex(
                  (item: { uuid: string }) => description.uuid === item.uuid
                );
                if (index > -1) {
                  const item = newData[index];
                  newData.splice(index, 1, {
                    ...item,
                    amount: formatNumber(value),
                  });
                  setDescriptions(newData);
                }
                let currentTotal: number = 0;
                newData.forEach((element: { amount: any }) => {
                  currentTotal += parseFloat(element.amount || "0");
                });
                setTotal(currentTotal + "");
                const amount = parseFloat(productData.amount || "0");
                const selectedArr = newData.filter((item: { uuid: string }) =>
                  selectedDescriptionsIds.includes(item.uuid)
                );
                let selectedTotal: number = 0;
                if (selectedArr.length > 0) {
                  selectedArr.forEach(
                    (element: { amount: any; uuid: string }) => {
                      if (element.uuid === description.uuid) {
                        selectedTotal += parseFloat(value || "0");
                      } else {
                        selectedTotal += parseFloat(element.amount || "0");
                      }
                    }
                  );
                }
                const per = ((amount - currentTotal) / amount) * 100;
                const ml = amount - currentTotal;
                const coefficient =
                  per > 30 && ml > 33000
                    ? "1.7"
                    : per > 30 && ml > 22000
                    ? " 1.6"
                    : per > 30 && ml > 11000
                    ? "1.5"
                    : "1";
                const sale = ml * parseFloat(coefficient);

                setDisableForm({
                  ...disabledForm,
                  预计毛利: ml.toFixed(2),
                  预计毛利率: ((ml / amount) * 100).toFixed(2),
                  收入额: (amount - selectedTotal).toFixed(2),
                  业绩系数: coefficient,
                  销售业绩额:
                    sale - (amount - selectedTotal) > 0
                      ? (amount - selectedTotal).toFixed(2)
                      : sale.toFixed(2),
                });
              }}>
              {description.name}
            </InputItem>
          ))}

        <div className="space"></div>
        <InputItem
          placeholder="请输入"
          extra="元"
          disabled={true}
          value={total}>
          成本预算总额
        </InputItem>
        <div className="space"></div>
        <InputItem extra="元" disabled={true} value={disabledForm.预计毛利}>
          预计毛利
        </InputItem>
        <InputItem extra="%" disabled={true} value={disabledForm.预计毛利率}>
          预计毛利率
        </InputItem>
        <InputItem extra="元" disabled={true} value={disabledForm.收入额}>
          收入额
        </InputItem>
        <InputItem disabled={true} value={disabledForm.业绩系数}>
          业绩系数
        </InputItem>
        <InputItem extra="元" disabled={true} value={disabledForm.销售业绩额}>
          销售业绩额
        </InputItem>
        <InputItem extra="元" disabled={true} value={disabledForm.应付小计}>
          应付小计
        </InputItem>
        <InputItem extra="元" disabled={true} value={disabledForm.应收小计}>
          应收小计
        </InputItem>
      </List>
      <Flex style={{ margin: "30px 0", padding: "0 30px" }}>
        <Flex.Item>
          <Button type="primary" onClick={onCancel}>
            上一步
          </Button>
        </Flex.Item>
        <Flex.Item>
          <Button
            type="primary"
            onClick={() => {
              const data: TrainingBudgetWrapper = {
                descriptions: descriptions,
                total: total,
                disabledForm: disabledForm,
              };
              onOk?.(data);
            }}>
            下一步
          </Button>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default TrainingStepThree;
